<template>
  <Header title="Detail Tagihan Siswa" link1="Tagihan" :link2="user.name"></Header>

  <div class="row gx-2">
    <div class="col-md-12">
      <div class="card h-100">
        <div class="card-body">
          <div class="row">
            <div class="col-md-3" style="padding-bottom:20px;text-align:center;">
              <div style="max-width:190px;" :class="{'photo-circle': true, 'red': user.status === 'Inactive'}">
                <img @error="onImageLoadFailure($event)" :src="imagepath" alt="">
              </div>
              <!-- <div class="btn btn-circle btn-gradient mt-3">Kirim Pesan</div> -->
            </div>
            <div class="col-md-8">
              <table class="table table-borderless table-detail">
                <tr><th>Nama</th><th>:</th><td>{{ user.name }}</td></tr>
                <tr><th>NIS</th><th>:</th><td> <a href="javascript:void(0)" class="no-pointer">{{ user.student_profile_nis}}</a> </td></tr>
                <tr><th>Sekolah</th><th>:</th><td>{{ school.name }}</td></tr>
                <tr><th>Kelas</th><th>:</th><td>{{ user.class_name}}</td></tr>
                <tr><th>Ayah</th><th>:</th><td>{{ user.parent_father}}</td></tr>
                <tr><th>Ibu</th><th>:</th><td>{{ user.parent_mother}}</td></tr>
                <tr v-if="isHideElementYkck"><th>Telepon</th><th>:</th><td>{{ user.user_profile_no_hp }}</td></tr>
                <tr v-if="user.status === 'Inactive'"><th>Status</th><th>:</th><td><span style="color:#DC3545;">{{ user.status }}</span></td></tr>
              </table>
            </div>
          </div>
          <div class="position-absolute top-0 end-0 p-2">
            <!-- <a href="#" class="btn-sm btn-link-gray">
              <ion-icon name="pencil"></ion-icon>
            </a> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row gx-2 mt-2">
    <div class="col-md-4">
      <div class="card h-100">
        <div class="card-body">
          <div class="m-4">
            <h5 class="text-secondary fw-bold">Total Tagihan</h5>
            <h4 class="d-inline text-primary fw-bold">Rp{{ toLocaleString(stats.total_bill) }}</h4>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <router-link :to="{ name: 'Payment', query: { child_user_id: user.user_id }}">
        <div class="card card-link h-100">
          <div class="card-body">
            <div class="m-4">
              <h5 class="text-secondary fw-bold">Total Terbayar</h5>
              <h4 class="d-inline text-success fw-bold">
                Rp{{ toLocaleString(stats.total_paid) }}
                <router-link :to="{ name: 'Payment', query: { child_user_id: user.user_id }}" class="btn btn-link-gray">
                  <ion-icon name="arrow-forward-circle-outline"></ion-icon>
                </router-link>
              </h4>
            </div>
          </div>
        </div>
      </router-link>
    </div>
    <div class="col-md-4">
      <div class="card h-100">
        <div class="card-body">
          <div class="m-4">
            <h5 class="text-secondary fw-bold">Sisa Pembayaran</h5>
            <h4 class="d-inline text-danger fw-bold">
              Rp{{ toLocaleString(totalUnpaid) }}
            </h4>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row pt-2">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-4">
              <button @click="$router.go(-1)" class="btn btn-light rounded-pill"> <ion-icon name="arrow-back-outline"></ion-icon> </button>
              <h4 class="text-secondary d-inline">Kembali</h4>
              <!-- <router-link to="/bill" tag="a" class="btn btn-circle btn-gradient"><ion-icon name=pencil></ion-icon> Atur Tagihan</router-link> -->
            </div>
            <div class="col-md-8">
              <div class="float-end">
                <!-- <label>Showing 1 - 20 of 305 results</label>
                <nav class="nav-bullet inline" aria-label="Page navigation example">
                  <ul class="pagination">
                    <li class="page-item active"><a class="page-link" href="#">1</a></li>
                    <li class="page-item"><a class="page-link" href="#">2</a></li>
                    <li class="page-item"><a class="page-link" href="#">3</a></li>
                  </ul>
                </nav>
                <div class="v-divider"></div> -->
                <div class="d-inline">
                  <label for="">Tahun Ajar:</label>
                  <select @change="loadData()" v-model="param.school_year_id" class="d-inline text-primary form-select form-select-noborder">
                    <option
                      v-for="sy in schoolYears"
                      :key="sy.school_year_id"
                      :label="sy.name"
                      :value="sy.school_year_id">
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row pt-2">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <table class="table table-borderless table-data fw-bold">
            <thead>
              <tr>
                <th v-if="adminCanGeneratePayment">
                  <input class="form-check-input" type="checkbox" value="" @click="checkAllBill()"
                    v-model="allSelectedBill">
                </th>
                <th>No</th>
                <th>Nama Tagihan <ion-icon @click="sort('bill_name')" name="swap-vertical-outline"></ion-icon></th>
                <th>Status <ion-icon @click="sort('status')" name="swap-vertical-outline"></ion-icon></th>
                <!-- <th>Bulan Bayar <ion-icon @click="sort('bill_month')" name="swap-vertical-outline"></ion-icon></th> -->
                <th>Batas <ion-icon @click="sort('deadline_date')" name="swap-vertical-outline"></ion-icon></th>
                <th class="text-end">Total Tagihan <ion-icon @click="sort('total_amount')" name="swap-vertical-outline"></ion-icon></th>
                <th class="text-end">Lunas <ion-icon @click="sort('total_paid')" name="swap-vertical-outline"></ion-icon></th>
                <!-- <th class="text-end">Kurang Bayar <ion-icon @click="sort('total_unpaid')" name="swap-vertical-outline"></ion-icon></th> -->
                <th>Terpublikasi</th>
                <th>Opsi</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(detail, i) in sortedUserBills" :key="detail.id">
                <td v-if="adminCanGeneratePayment">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" :value="detail.id" v-model="billIds"
                      v-if="(detail.status == constants.BILL_PENDING || detail.status == constants.BILL_UNPAID)">
                  </div>
                </td>
                <td>{{ i + 1 }}</td>
                <td>{{ detail.bill.name }} <span class="badge bg-info">{{ getMonth(detail.id)}}</span></td>
                <td>
                  <div v-if="detail.status == constants.BILL_PAID" class="btn btn-sm btn-outline-success rounded-pill no-pointer">LUNAS</div>
                  <div v-if="detail.status == constants.BILL_OVERPAID" class="btn btn-sm btn-outline-success rounded-pill no-pointer">KELEBIHAN</div>
                  <div v-if="detail.status == constants.BILL_PENDING" class="btn btn-sm btn-outline-warning rounded-pill no-pointer">AKTIF</div>
                  <div v-if="detail.status == constants.BILL_UNPAID" class="btn btn-sm btn-outline-warning rounded-pill no-pointer">BELUM BAYAR</div>
                </td>
                <!-- <td> <span class="badge bg-info">{{ getMonth(detail.id)}}</span></td> -->
                <td>{{ detail.deadline_date }}</td>
                <td class="text-end text-primary">Rp{{ toLocaleString(detail.total_payment) }}</td>
                <td class="text-end text-success">Rp{{ toLocaleString(detail.total_paid) }}</td>
                <!-- <td class="text-end">Rp{{ toLocaleString(detail.total_unpaid) }}</td> -->
                <td>
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" :checked="detail.is_published == 1" @click="publishByID(detail, $event)">
                  </div>
                </td>
                <td>
                  <button v-if="canUpdate && (detail.status == constants.BILL_PENDING || detail.status == constants.BILL_UNPAID)" type="button" class="btn btn-sm btn-link-gray" @click="edit('edit', detail.spp_bill_id, detail.id)" data-bs-toggle="modal" data-bs-target="#billUserModal"><ion-icon name="create-outline"></ion-icon></button>
                  <button v-if="detail.status == constants.BILL_PAID || detail.status == constants.BILL_OVERPAID" type="button" class="btn btn-sm btn-link-gray" @click="edit('detail', detail.spp_bill_id, detail.id)" data-bs-toggle="modal" data-bs-target="#billUserModal"><ion-icon name="create-outline"></ion-icon></button>
                  <a href="javascript:void(0)" v-bind:class="{'disabled': (loading[detail.id]) }"
                    v-if="(detail.status == constants.BILL_PENDING || detail.status == constants.BILL_UNPAID) && (detail.spp_order_ids == undefined || isCanceled(detail.spp_order_ids)) && adminCanGeneratePayment"
                    class="btn btn-warning btn-sm" @click="checkout(detail.id, detail.spp_order_ids)">
                    <ion-icon name="card-outline" v-if="loading[detail.id] != true"></ion-icon><i class="fa fa-spinner fa-pulse" v-if="loading[detail.id] == true"></i> Generate
                  </a>
                  <a href="javascript:void(0)"
                    v-if="((detail.status == constants.BILL_PAID || detail.status == constants.BILL_OVERPAID) || (detail.spp_order_ids && !isCanceled(detail.spp_order_ids))) && adminCanGeneratePayment"
                    class="btn btn-warning btn-sm" @click="invoice(detail.spp_order_ids[0])">
                    <ion-icon name="reader-outline"></ion-icon> Invoice
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="row">
            <div class="col-12">
              <div class="legend legend-info"></div> Terpublikasi
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-if="billIds.length > 0 && adminCanGeneratePayment" class="row pt-2">
    <div class="col-md-12">
      <div class="card h-100">
        <div class="card-body">
          <div class="m-3" style="display: flex; justify-content: space-between; align-items: center;">
            <div>
              <h5 class="text-secondary">Total Tagihan Dipilih</h5>
              <h3 class="d-inline text-primary fw-bold">Rp{{ totalSelectedAmount }}</h3>
            </div>
            <div>
              <a href="javascript:void(0)" v-bind:class="{'disabled': (billIds.length == 0 || loadingBulk)}"
                @click="bulkCheckout()" class="d-inline btn btn-lg btn-warning float-end">
                <ion-icon name="card-outline" v-if="loadingBulk == false"></ion-icon><i class="fa fa-spinner fa-pulse"
                  v-else></i> Generate Pembayaran Terpilih
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="convenienceFeeModal" class="modal" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Pilih Metode Pembayaran</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form class="row g-3">
            <template v-if="paymentMethod">
              <div v-for="(value, key) in convenienceFee" :key="key">
                <input type="radio" class="btn-check" :value="value.id" :name="value.name" v-model="convenience_id">
                <label class="btn btn-outline-primary w-100" @click="handleConvenienceFee(value.id)">{{ value.name
                  }}</label>
              </div>
            </template>
            <template v-if="!paymentMethod">
              <div class="col-md-12 mb-3">
                <b class="text-secondary d-inline">
                  <button @click="paymentMethod = true; convenience_id = 0" type="button" class="btn btn-light btn-sm rounded-pill"> <ion-icon
                      name="arrow-back-outline"></ion-icon> </button>
                  Kembali
                </b>
              </div>
              <div class="col-md-12 mb-3">
                <label for="" class="form-label">Nominal</label>
                <CurrencyInputDisable v-model="payment.amount" :options="config" />
              </div>
              <div class="col-md-12 mb-3">
                <label for="" class="form-label">Biaya Admin</label>
                <CurrencyInputDisable v-model="payment.convenience_fee" :options="config" />
              </div>
              <div class="col-md-12 mb-3">
                <label for="" class="form-label">Biaya Merchant</label>
                <CurrencyInputDisable v-model="payment.merchant_fee" :options="config" />
              </div>
              <div class="col-md-12 mb-3">
                <label for="" class="form-label">Potongan Harga</label>
                <CurrencyInputDisable v-model="payment.total_discount" :options="config" />
              </div>
              <div class="col-md-12 mb-3" v-if="payment.ppn > 0">
                <label for="" class="form-label">PPN</label>
                <CurrencyInputDisable v-model="payment.ppn" :options="config" />
              </div>
              <div class="col-md-12 mb-3">
                <label for="" class="form-label">Total Bayar</label>
                <CurrencyInputDisable v-model="payment.total_amount" :options="config" />
              </div>
            </template>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal"> <ion-icon
              name="close-outline"></ion-icon> Tutup</button>
          <button v-if="!paymentMethod" type="button" :disabled="loadingBulk" class="btn btn-primary"
            @click="checkOutConvenience()">
            <ion-icon name="card-outline" v-if="!loadingBulk"></ion-icon>
            <i class="fa fa-spinner fa-pulse" v-else></i>
            Bayar
          </button>
        </div>
      </div>
    </div>
  </div>

  <div id="bcaModal" class="modal" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Pembayaran</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <table style="width: 100%;">
            <tr v-if="bca.invoice_number">
              <td style="padding: 10px;">No Invoice</td>
              <td style="padding: 10px;"> : </td>
              <td style="text-align:right; padding: 10px;">{{ bca.invoice_number }}</td>
            </tr>
            <tr>
              <td style="padding: 10px;">Nomor Va</td>
              <td style="padding: 10px;"> : </td>
              <td style="text-align:right; padding: 10px;">{{bca.bank_name}} {{bca.va_number}}</td>
            </tr>
            <tr>
              <td style="padding: 10px;">Total Biaya</td>
              <td style="padding: 10px;"> : </td>
              <td style="text-align:right; padding: 10px;">{{ formatPrice(bca.amount) }}</td>
            </tr>
            <tr>
              <td style="padding: 10px;">Biaya Admin</td>
              <td style="padding: 10px;"> : </td>
              <td style="text-align:right; padding: 10px;">{{ formatPrice(bca.convenience_fee) }}</td>
            </tr>
            <tr>
              <td style="padding: 10px;">Biaya Merchant</td>
              <td style="padding: 10px;"> : </td>
              <td style="text-align:right; padding: 10px;">{{ formatPrice(bca.merchant_fee) }}</td>
            </tr>
            <tr>
              <td style="padding: 10px;">Total Diskon</td>
              <td style="padding: 10px;"> : </td>
              <td style="text-align:right; padding: 10px;">-{{ formatPrice(bca.total_discount) }}</td>
            </tr>
            <tr>
              <td style="padding: 10px;">PPN</td>
              <td style="padding: 10px;"> : </td>
              <td style="text-align:right; padding: 10px;">{{ formatPrice(bca.ppn) }}</td>
            </tr>
            <tr>
              <td style="padding: 10px;"><b>Total Bayar</b></td>
              <td style="padding: 10px;"><b> : </b></td>
              <td style="text-align:right; padding: 10px;"><b>{{ formatPrice(bca.total_payment) }}</b></td>
            </tr>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal"> <ion-icon
              name="close-outline"></ion-icon> Tutup</button>
        </div>
      </div>
    </div>
  </div>

  <edit-user-bill :data="data" :math_operations="math_operations" @loadData="loadData"></edit-user-bill>

  <div id="xenditModal" class="modal" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Pembayaran</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <iframe v-if="xenditInvoice != ''" :src="xenditInvoice" frameborder="0" width="100%" height="700"></iframe>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" @click="loadData()"> <ion-icon name="close-outline"></ion-icon> Tutup</button>
        </div>
      </div>
    </div>
  </div>

</template>

<style scoped>
.photo-circle {
  width: 190px;
  height: 190px;
  object-fit: cover;
}

.red {
  border-color: #DC3545;
}
</style>

<script language="ts" src="./scripts/bill-detail.ts"></script>
